export class TransformationRuleDTO{

    public id!:number;
    public sequenceNo!:number;
    public transformationRuleDefinitionId!:number;
    public transformationParameter1?:string;
    public transformationParameter2?:string;
    public inputPassthrough:boolean = false;
    public breakOnConditionMet:boolean = false;

}